import pkReducer from "./reducers"

export default pkReducer